module.exports = __webpack_public_path__ + "static/WerewolfTransformation-155ce82106184aeefc214c995ebe740c.jpg";